import { Component, OnInit, setTestabilityGetter } from '@angular/core';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { Router, ActivatedRoute } from '@angular/router';
import { RolePermissionService } from 'src/modules/base/shared/services/role-permission.service';
import { UtilService } from 'src/modules/base/services/util.service';
import { TranslateService } from 'src/modules/base/services/translate.service';

@Component({
    selector: 'kx-per-patient-track-status',
    templateUrl: './per-patient-track-status.component.html',
    styleUrls: ['./per-patient-track-status.component.scss'],
    standalone: false
})
export class PerPatientTrackStatusComponent implements OnInit {
  applicationName: string;
  patientName: any;
  keys: any = [];
  patientData: any = false;
  temp: any;
  bannerJson: any;
  data: string;
  showobjarray: boolean = false;
  dataListForDhsGRid: any;
  fields: any = false;
  station_status: any;
  configList: any;
  PageTitle: string="";
  table_heading: any[] = [];

  constructor(
    private baseService: BaseService,
    private route: Router,
    private Aroute: ActivatedRoute,
    public roleService: RolePermissionService,
    public utilService: UtilService,
    public translateService: TranslateService
  ) { }

  ngOnInit() {
    this.data = JSON.parse(sessionStorage.getItem('currentData'));
    //console.log("oId IOId", this.data);
    this.Aroute.data.subscribe(data => {
      if (data && data.resource != undefined) {
        this.getCurrentResource(data.resource);
      }
      else {
        this.Aroute.params.subscribe((res) => {
          this.applicationName = this.route.url.split("/")[1]
          this.getResource(res.resource);
        })
      }
    });
    this.configList = {
      "viewAll": true,
      "hideSearchBox": true,
      "hideResult": true,
      "allowPagination": false,
      "print_allowed": false
    }
    this.baseService.backNavigation = true
  }
  //get current resource
  getCurrentResource(resource) {
    let allPromiseObj: any = [];
    this.baseService.getResourceDef(resource, (resouceDef) => {
      if (resouceDef) {

        this.setTitle(resouceDef.page_name!=undefined && resouceDef.page_name.list!=undefined? resouceDef.page_name.list : "");
        if (resouceDef.metro != undefined) {
          for (let i = 0; i < resouceDef.metro.length; i++) {
            allPromiseObj.push(this.get_stations_stationstatus(resouceDef.metro[i]));
          }
          //to the stuff when all promises are done with there work
          // if (this.station_status != undefined && this.station_status) {
          Promise.all(allPromiseObj)
            .then(() => {
              // for (let i = 0; i < resouceDef.metro.length; i++) {
              this.setPatientData_(this.station_status);
              // }
            })
            .catch((e) => {
              // handle errors here
            });
        }
        if (resouceDef.banner) {
          if (resouceDef.banner.key != undefined && resouceDef.banner.key.includes("!!!data!!!")) {
            resouceDef.banner.key = this.data;
          }
          setTimeout(x => { this.setBanner(resouceDef.banner); })
        }
        if (resouceDef.list != undefined) {
          this.fields = resouceDef.list.fields;
          this.getGridData(resouceDef.list.datasource);
          this.table_heading = resouceDef.list.table_heading
            ? (Array.isArray(resouceDef.list.table_heading) ? resouceDef.list.table_heading : [resouceDef.list.table_heading])
            : [];
        }
      }
    });



  }

  setTitle(val) {
    console.log({val});
    if (val) {
      this.translateService.translate(val).subscribe(val_ => {
        console.log("value is", val_);
        if (val_) {
          this.PageTitle = val_;
          this.baseService.setTitle(val_);
        }
      });
    }
    else {
      this.baseService.setTitle("Clearance Status");
    }
  }

  getResource(resourceName: any) {
    this.baseService.getResourceDef(resourceName, (resourceDef) => {
      if (resourceDef.banner)
        this.setBanner(resourceDef.banner)
      this.getPatientdata(resourceDef);
      this.setTitle(resourceDef.page_name!=undefined && resourceDef.page_name.list!=undefined? resourceDef.page_name.list : "");
    })
  }
  //set Banner
  setBanner(bannerJson) {
    if(bannerJson.datasource != undefined){
      bannerJson.datasource.args = bannerJson.datasource.args != undefined ? this.baseService.buildDyanamicStr(bannerJson.datasource.args, { data: this.data }) : '';
    }
    this.bannerJson = bannerJson;
  }
  //list
  getGridData(datasource) {
    // debugger;
    datasource.args = datasource.args != undefined ? this.baseService.buildDyanamicStr(datasource.args, { data: this.data }) : '';
    datasource.filter = datasource.filter != undefined ? this.baseService.buildDyanamicStr(datasource.filter, { data: this.data }) : '';

    this.baseService.get(datasource.query_id, datasource.args, datasource.resource, datasource.application, datasource.filter).subscribe(data_ => {
      // debugger
      if (data_ != undefined && data_.resource != undefined && data_.resource.length > 0) {
        this.dataListForDhsGRid = data_;
      }
    });
  }
  //setting status station and station status
  get_stations_stationstatus(info) {
    return new Promise<void>((resolve, reject) => {
      info.datasource.args = info.datasource.args != undefined ? this.baseService.buildDyanamicStr(info.datasource.args, { data: this.data }) : '';
      info.datasource.filter = info.datasource.filter != undefined ? this.baseService.buildDyanamicStr(info.datasource.filter, { data: this.data }) : '';
      // get(queryId, args, resource = null, application?: any, filter?: any, responseType?: any)
      this.baseService.get(info.datasource.query_id, info.datasource.args, info.datasource.resource, info.datasource.application, info.datasource.filter).subscribe(data => {
        console.log("get data is as is as::", data);
        if (data && data.resource != undefined && data.resource.length>0){
          if (info.name == 'station_name') {
            this.showobjarray = true;
            for (let i = 0; i < data.resource.length; i++) {
              this.keys.push({ "key": data.resource[i][info.key], "display": data.resource[i][info.display] });
            }
          }
          else if (info.name == 'station_status') {
            this.station_status = data.resource;
          }
          resolve();
        } else {
          console.log(" Error Message : "+ data.message);
        }
      })
      console.log("data set is as", name);
    });
  }

  getPatientdata(resource: any) {
    this.baseService.get(resource.datasource.query_id, this.makeArgs(resource), resource.resource, resource.datasource.application).subscribe((data) => {
      this.patientName = data.resource[0].patient_name;
      this.temp = data.resource[0].data.sort(function (a, b) { return a.sequence - b.sequence })
      this.setPatientData(this.temp);
      this.keys = Object.keys(this.patientData);
      if(this.temp.length == 0){
        this.previous()
      }
    })
  }

  makeArgs(args) {
    var p = [];
    for(let i = 0; i < Object.keys(args.datasource.args).length; i++) {
      if (Object.keys(args.datasource.args)[i] != "application")
        p.push(Object.keys(args.datasource.args)[i] + ":" + this.keysend(Object.keys(args.datasource.args)[i]))
      else
        p.push(Object.keys(args.datasource.args)[i] + ":" + this.applicationName)
    }
    return p.join(",")
  }

  setPatientData(temp) {
    this.patientData = {}
    for(let i = 0; i < temp.length; i++) {
      this.patientData[temp[i]['stage']] = temp[i]['status']
    }
  }

  setPatientData_(temp) {
    this.patientData = {}
    if (temp.length == 1) {
      for (let i = 0; i < this.keys.length; i++) {
        for (let key in temp[0]) {
          if (this.keys[i].key === key) {
            this.patientData[this.keys[i]['key']] = temp[0][key];
          }

        }
      }
    }
    console.log("this.patientDatathis.patientData", this.patientData);
  }

  previous() {
    this.Aroute.queryParams.subscribe((result) => {
      this.route.navigateByUrl(result['returnUrl'])
    })
  }

  redirectToLink(res: any) {
    this.baseService.getResourceDef(res.stage_id, (resouceDef) => {
      console.log("resource def is :: ", resouceDef, "json is :: ", res.stage_id.json);
      if (resouceDef) {
        this.route.navigate(['/' + this.applicationName + '/' + res.stage_id + '/add'], { queryParams: { key: this.data['tableId'], returnUrl: this.route.url } });
      }
    })
  }

  public keysend(key: any) {
    return JSON.parse(sessionStorage.getItem('currentData'))[key]
  }

  public getStyle(count) {
    return { "width": (100 / count) + "%" }
  }

  getButton() {
    return "saurav"
  }

}
